import React from 'react';
import { Grid, Input } from '@material-ui/core';

import { Page, Content, ContentHeader } from '@backstage/core-components';

import { useEntity } from '@backstage/plugin-catalog-react';
import {
  TechRadarComponent,
  TechRadarPageProps,
} from '@backstage-community/plugin-tech-radar';

export const TechradarCard = (props: TechRadarPageProps) => {
  const {
    title = 'Tech Radar',
    subtitle = 'Pick the recommended technologies for your projects',
    pageTitle = 'Custom Radar',
    ...componentProps
  } = props;
  const { entity } = useEntity();
  const [searchText, setSearchText] = React.useState('');

  return (
    <Page themeId="tool">
      <Content>
        <ContentHeader title={pageTitle}>
          <Input
            id="custom-tech-radar-filter"
            type="search"
            placeholder="Filter"
            onChange={e => setSearchText(e.target.value)}
          />
        </ContentHeader>
        <Grid container spacing={3} direction="column">
          <Grid container spacing={3} direction="row">
            <Grid item xs={12} sm={6} md={4}>
              <TechRadarComponent
                searchText={searchText}
                id={
                  entity?.metadata?.annotations![
                    'schema.dp.netrtl.com/legacy-short-key'
                  ]
                }
                {...componentProps}
              />
            </Grid>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
